// extracted by mini-css-extract-plugin
export default {"walletButton":"WalletButton_walletButton__T-zCn","header":"WalletButton_header__gUgiK"};